module.exports = __webpack_public_path__ + "assets/img/stewed_active.e3d6d437.png";